export default "__VITE_ASSET__VVxntSpH__"